import type { DominoRuleSet } from './types.js';

/**
 * All Fives (Muggins). Double-six set, draw-from-boneyard, classic 4-arm
 * spinner. Score on every play where the sum of open ends is a multiple of
 * 5. End-of-hand bonus = loser's remaining pip total rounded to the nearest
 * 5. Match ends at the target score (default 150).
 */
export const ALL_FIVES: DominoRuleSet = {
  id: 'all-fives',
  setSize: 28,
  maxPip: 6,
  handSize: { 2: 7, 3: 6, 4: 5 },
  pointGoal: 150,
  drawRule: 'draw-until-playable',
  spinner: true,
  mugginsStrict: true,
  mugginsClaimWindowMs: 3000,
  scoreMultiple: 5,
  scoring: 'fives',
  partnership: false,
  firstHandLeadPriority: null,
  leadScoresOnlyOnDoubleFive: false,
  nextHandLeader: 'winner',
  opening13: false,
  baldFinish: false,
};

export const ALL_FIVES_PARTNERSHIP: DominoRuleSet = {
  ...ALL_FIVES,
  id: 'all-fives-2v2',
  partnership: true,
};
